import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'
import { constants } from './constants'

enum UserRoleName {
    Owner = 'Owner',
    Admin = 'Admin',
    Member = 'Member',
    Guest = 'Guest',
}

const userRolesFromId: Record<string, UserRoleName> = {
    [constants.roles.meetplaceOwner]: UserRoleName.Owner,
    [constants.roles.meetplaceAdmin]: UserRoleName.Admin,
    [constants.roles.meetplaceMember]: UserRoleName.Member,
    [constants.roles.meetplaceGuest]: UserRoleName.Guest,
} as const

const userRolesToId: Record<UserRoleName, string> = {
    [UserRoleName.Owner]: constants.roles.meetplaceOwner,
    [UserRoleName.Admin]: constants.roles.meetplaceAdmin,
    [UserRoleName.Member]: constants.roles.meetplaceMember,
    [UserRoleName.Guest]: constants.roles.meetplaceGuest,
} as const

const useTranslateUserRole = (): {
    getUserRoleTranslatedName: (roleId: string) => string
} => {
    const t = useTranslations()

    const userRolesTranslations = useMemo(
        () => ({
            [constants.roles.meetplaceOwner]: t('glossary.owner'),
            [constants.roles.meetplaceAdmin]: t('glossary.admin'),
            [constants.roles.meetplaceMember]: t('glossary.member'),
            [constants.roles.meetplaceGuest]: t('glossary.guest'),
        }),
        [t],
    )
    const getUserRoleTranslatedName = useCallback(
        (roleId: string): string => userRolesTranslations[roleId],
        [userRolesTranslations],
    )

    return { getUserRoleTranslatedName }
}

export { UserRoleName, userRolesFromId, userRolesToId, useTranslateUserRole }
